"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {},
  header: {
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 30px',
    cursor: 'pointer',
    borderBottom: "1px solid ".concat(_styles.colors.gray),
    transition: 'all 0.3s',
    background: function background(_ref) {
      var open = _ref.open;
      return open ? 'rgba(0, 0, 0, 0.05)' : 'transparent';
    },
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.05)'
    }
  },
  iconContainer: {
    transition: 'all 0.3s',
    transform: function transform(_ref2) {
      var open = _ref2.open;
      return open ? 'rotate(-180deg)' : '';
    }
  },
  content: {
    borderBottom: function borderBottom(_ref3) {
      var open = _ref3.open;
      return "".concat(open ? 1 : 0, "px solid ").concat(_styles.colors.gray);
    },
    transition: 'all 0.3s',
    padding: function padding(_ref4) {
      var open = _ref4.open;
      return open ? '5px 30px' : '0 30px';
    },
    overflow: function overflow(_ref5) {
      var open = _ref5.open;
      return open ? 'auto' : 'hidden';
    },
    maxHeight: function maxHeight(_ref6) {
      var open = _ref6.open;
      return open ? '1000px' : '0px';
    },
    opacity: function opacity(_ref7) {
      var open = _ref7.open;
      return open ? 1 : 0;
    }
  }
};
var _default = styles;
exports["default"] = _default;